import * as React from 'react';
import {Button, Card, CardBody, Col, Container, Row} from 'reactstrap';
import MagnifyIcon from 'mdi-react/MagnifyIcon';
import CloseCircleIcon from 'mdi-react/CloseCircleIcon';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {Store} from 'react-redux';
import VisicoolersTable from './visicooler-cliente-table';
import {lazyInject, TYPES} from '../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../middleware/mirana-client';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import './visicooler-cliente.scss';
import {error, success} from '../../../../utils/notification-actions';
import FileExcelIcon from 'mdi-react/FileExcelIcon';
import fileDownload from 'js-file-download';
import {getFileName} from '../../../../utils/utils';
import MiranaState from '../../../../reduxstore/mirana-state';
import {FuerzasVenta, IFuerzaVenta} from '../../../../utils/constants';
import VisicoolerClienteForm from './visicooler-cliente-form';

interface IState {
    keyword: string;
    response?: mirana.BuscarVisicoolersResponse;
    fuerzaVenta?: IFuerzaVenta;
    descargaHabilitada: boolean;
    periodo: string;
}

class VisicoolerCliente extends React.Component<RouteComponentProps<any>, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {
            keyword: '',
            periodo: '',
            descargaHabilitada: false
        };
    }

    public componentWillReceiveProps(newProps) {
        let fuerzaVenta;
        for (const key in FuerzasVenta) {
            if (FuerzasVenta[key].abbrv === newProps.match.params.fuerzaVenta) {
                fuerzaVenta = FuerzasVenta[key];
            }
        }
        this.setState({fuerzaVenta});
        this.setState({response: undefined})
        /* this.apiClient.filtrarVisicoolers(fuerzaVenta ? fuerzaVenta.id : '', periodo).then((response) => {
             this.setState({response});
         });*/
    }

    public componentDidMount() {
        let fuerzaVenta;
        for (const key in FuerzasVenta) {
            if (FuerzasVenta[key].abbrv === this.props.match.params.fuerzaVenta) {
                fuerzaVenta = FuerzasVenta[key];
            }
        }
        this.setState({fuerzaVenta});
        /*this.apiClient.filtrarVisicoolers(fuerzaVenta ? fuerzaVenta.id : '').then((response) => {
            this.setState({response});
        });*/
    }

    private buscarViscoolersOnEnter = async (e) => {
        const {keyword} = this.state;
        if (e.key === 'Enter' && keyword && keyword.length >= 3) {
            this.buscarVisicoolers();
        }
    };

    private buscarVisicoolersOnClick = () => {
        const {keyword} = this.state;
        if (keyword && keyword.length >= 3) {
            this.buscarVisicoolers();
        }
    };

    private cancelarBusquedaOnClick = () => {
        const {fuerzaVenta, periodo} = this.state;
        this.apiClient.filtrarVisicoolers(fuerzaVenta ? fuerzaVenta.id : '', periodo).then((response) => {
            this.setState({response});
        });
        this.setState({keyword: ''})
    };

    public handleFiltrar = async (values) => {
        const periodo = values.periodo ? values.periodo.value : null;

        try {
            const {fuerzaVenta} = this.state;
            this.setState({
                periodo,
                descargaHabilitada: true
            });
            this.apiClient.filtrarVisicoolers(fuerzaVenta ? fuerzaVenta.id : '', periodo).then((response) => {
                this.setState({response});
            });
            this.reduxStore.dispatch(success('Notificación', 'Registros encontrados'));
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Error interno al filtrar visicoolers'));
        }
    }

    private buscarVisicoolersPaginado = async (page: number) => {
        this.buscarVisicoolers(page);
    };

    public handleGenerarExcel = async () => {
        try {
            const {fuerzaVenta, periodo} = this.state;
            const response = await this.apiClient.descargarVisicoolers(fuerzaVenta ? fuerzaVenta.id : '', periodo);
            fileDownload(response.data, getFileName(response));
            this.reduxStore.dispatch(success('Notificación', 'Excel generado correctamente'));
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Error interno al generar excel de visicoolers'));
        }
    };

    private actualizarData = (data: mirana.BuscarVisicoolersResponse) => {
        this.setState({response: data});
    };

    private buscarVisicoolers = async (page?: number) => {
        const {keyword, fuerzaVenta, periodo} = this.state;
        const response = await this.apiClient.filtrarVisicoolers(fuerzaVenta ? fuerzaVenta.id : '', periodo, keyword, page);
        this.setState({response});
    };

    private handleKeywordChange = (e) => {
        this.setState({keyword: e.target.value})
    };

    private handlePeriodoChange = () => {
        this.setState({descargaHabilitada: false});
    };

    private get cancelarButton() {
        if (this.state.keyword !== '') {
            return <button className='form__form-group-button'
                           onClick={this.cancelarBusquedaOnClick}>
                <CloseCircleIcon/>
            </button>
        }
        return null;
    };

    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>{this.state.fuerzaVenta ? this.state.fuerzaVenta.descripcion : ''}:
                            Visicoolers Asignados</h3>
                    </Col>
                    <Col md={12} lg={12}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <VisicoolerClienteForm onSubmit={this.handleFiltrar}
                                                           fuerzaVenta={this.state.fuerzaVenta}
                                                           handlePeriodoChange={this.handlePeriodoChange}/>
                                </Row>
                                <Row>
                                    <Col md={4} lg={4}>
                                        <div className='form'>
                                            <div className='form__form-group'>
                                                <div className='form__form-group-field'>
                                                    <input name='search' type='text'
                                                           autoComplete='off'
                                                           placeholder='Buscar por código de cliente o razón social'
                                                           value={this.state.keyword}
                                                           onChange={this.handleKeywordChange}
                                                           onKeyPress={this.buscarViscoolersOnEnter}/>
                                                    {this.cancelarButton}
                                                    <button className={`form__form-group-button`}
                                                            onClick={this.buscarVisicoolersOnClick}><MagnifyIcon/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={8} lg={8}>
                                        <Button onClick={this.handleGenerarExcel} color='success'
                                                disabled={!this.state.descargaHabilitada}
                                                className='visicooler-add-button'><FileExcelIcon/></Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} lg={12}>
                                        <VisicoolersTable data={this.state.response} keyword={this.state.keyword}
                                                          fuerzaVenta={this.state.fuerzaVenta}
                                                          handlePagination={this.buscarVisicoolersPaginado}
                                                          actualizarData={this.actualizarData}/>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(VisicoolerCliente);


// WEBPACK FOOTER //
// ./src/components/pages/visicooler/clientes/visicooler-cliente.tsx